import React from 'react';
// import Avatar from '../avatar/Avatar';
import AboutMenue from './AboutMenu';

export default function About() {
  return (
    <>
      {/* <Avatar page="about" /> */}
      <AboutMenue />
    </>
  );
}
